import $ from 'jquery'
import ImportMedicament from '@/views/medicaments/importer-medicament'
import EnteteBonEtFacture from '@/views/en-tete-bon-facture'
import RecapStock from '@/views/recap-stock'
import RecapProduits from '@/components/recap-produits'
import store_medicaments from "@/store/mods/stock/medicaments"
import { correspondRecherche } from '@/utils/catalogue-search'


export default {
    name: "medicaments",
    components: { 
        ImportMedicament, EnteteBonEtFacture,
        RecapStock, RecapProduits
    },
    props: [],
    data() {
        return {
            fields: [
                "num",
                "produit",
                "cdmt",
                { key: 'date_peremption', label: 'Date péremption' },
                { key: 'seuil', label: 'Seuil (Min/Opt)' },
                "prix_cession",
                "prix_public",
                { key: 'nombre_disponible', label: 'Qté disponible' },
                "actions",
            ],
            print_fields: [
                "num",
                "produit",
                "cdmt",
                "prix_cession",
                "prix_public",
                "nombre_disponible",
            ],
            filter: "",
            filtre_categorie: '',
            perPage: 50,
            search_word: "",
            currentPage: 1,
            print_per_page: -1,
            v: 0,
            user_role: "",

            can_delete_medicament: false,
            med_to_be_deleted: [],
            list_medicament: [],
            del_loading: false,
            is_confirm: false,
            is_printing: false,
            can_print: false,
            filename: "",

            is_loading: true,
            is_empty: false,

            json_fields: {
                'Libellé': 'libelle',
                'Seuil minimum': 'seuil_minimum',
                'Seuil optimal': 'seuil_optimal',
                'Prix public': 'prix_public',
                'Catégorie': 'categorie',
                'Prix cession': 'prix_cession',
                'Dosage': 'dosage',
                'Unité dosage': 'unite_dosage',
                'Conditionnement': 'conditionnement',
                'Forme': 'forme',
                'Qté disponible': 'qte_disponible'
            },

            json_data: [],
            export_filename: 'Liste_Medicaments.xls',
            loading_all_article: true,
            all_article_is_empty: false,
            liste_medicaments: [],
            type_article_id: 1,
            recap_stock: [],
            recap_is_loading: false,

            modal_title: '',
            produits: [],
            modal_toggler: 0,
            has_day: false,
        };
    },
    computed: {
        categories_recherche() {
            const noms = Array.from(new Set(this.liste_medicaments.map(groupe => groupe.categorie).filter(Boolean)))
            return [{ value: '', label: 'Toutes les catégories' }, ...noms.map(nom => ({ value: nom, label: nom }))]
        },
        categorie_selectionnee: {
            get() { return this.categories_recherche.find(cat => cat.value === this.filtre_categorie) || this.categories_recherche[0] },
            set(categorie) { this.filtre_categorie = categorie ? categorie.value : '' },
        },
        medicaments_recherche() {
            return this.liste_medicaments.reduce((resultats, groupe) => {
                if (this.filtre_categorie && groupe.categorie !== this.filtre_categorie) return resultats
                ;(groupe.medicaments || []).forEach(medicament => {
                    if (correspondRecherche([medicament.medicament, medicament.libelle, medicament.dosage,
                        medicament.forme, medicament.conditionnement, medicament.lot_article, groupe.categorie], this.filter)) {
                        resultats.push({ ...medicament, categorie: groupe.categorie, categorie_id: groupe.categorie_id })
                    }
                })
                return resultats
            }, [])
        },
        medicaments_groupes() {
            const debut = (this.currentPage - 1) * this.perPage
            const groupes = new Map()
            this.medicaments_recherche.slice(debut, debut + this.perPage).forEach((medicament, index) => {
                const cle = medicament.categorie_id == null ? medicament.categorie : medicament.categorie_id
                if (!groupes.has(cle)) groupes.set(cle, { categorie_id: cle, categorie: medicament.categorie || 'Sans catégorie', medicaments: [] })
                groupes.get(cle).medicaments.push({ ...medicament, numero_affichage: debut + index + 1 })
            })
            return Array.from(groupes.values())
        },
        categories() {
            return this.$store.getters["categories"];
        },

        userCredentials() {
            return this.$store.getters["authInfo"];
        },

        activeRole() {
            return this.$store.getters["activeRole"];
        },
    },
    watch: {
        filter() { this.currentPage = 1 },
        filtre_categorie() { this.currentPage = 1 },
        perPage() { this.currentPage = 1 },
    },
    mounted() {
        this.$store.commit("SET_LOT_ARTICLE_REF_ID", null)
        setTimeout(() => {
            $(".p-content").fadeIn();
        }, 500);

        this.selectListeTousMedicaments()


        this.getListeMedicamentByCategory()

        if (this.userCredentials.user.roles.length > 0) {
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.activeRole.nom == "ROLE_INFIRMIER") {
                this.$router.push({ path: "/ventes" });
            }

            if (this.activeRole.nom == "ROLE_ADMINISTRATEUR") {
                this.can_delete_medicament = true;
            }
        }
        var d = new Date();
        var tmpstamp = d.getHours() + "" + d.getMinutes() + "" + d.getFullYear();

        this.filename = "Liste_des_medicaments_" + tmpstamp;

        this.getRecapStock() 
    },

    methods: {
        selectListeTousMedicaments() {
            this.loading_all_article = true
            store_medicaments.getAllArticles().then((response) => {
                let all_articles = response
                console.log("r: ",response);
                
                
                if (all_articles.length > 0) {
                    all_articles.forEach(article => {
                        this.json_data.push({
                            'libelle' : article.libelle,
                            'seuil_minimum': (article.minimum > 0)?article.minimum:'', 
                            'seuil_optimal': (article.optimale > 0)?article.optimale:'', 
                            'prix_public': (article.prix > 0)?article.prix:'',
                            'categorie' : article.categorie?.libelle,
                            'prix_cession': (article.prix_cession > 0)?article.prix_cession:'',
                            'dosage': article.dosage,
                            'unite_dosage': article.unite_dosage?.libelle,
                            'conditionnement': article.conditionnement,
                            'forme': article.forme?.libelle,
                            'qte_disponible': article.qte_disponible
                        })
                    });
                }
            })
        },

        getListeMedicamentByCategory() {
            this.is_loading = true

            store_medicaments.listeMedicamentsOrdonne().then((response) => {
                this.liste_medicaments = response
                this.currentPage = 1
                
                if (this.liste_medicaments.length > 0) {
                    this.is_empty = false
                    // this.liste_medicaments.medicaments.forEach(article => {
                    //     this.json_data.push({
                    //         'libelle' : article.libelle,
                    //         'seuil_minimum': (article.minimum > 0)?article.minimum:'', 
                    //         'seuil_optimal': (article.optimale > 0)?article.optimale:'', 
                    //         'prix_public': (article.prix > 0)?article.prix:'',
                    //         'categorie' : article.categorie?.libelle,
                    //         'prix_cession': (article.prix_cession > 0)?article.prix_cession:'',
                    //         'dosage': article.dosage,
                    //         'unite_dosage': article.unite_dosage?.libelle,
                    //         'conditionnement': article.conditionnement,
                    //         'forme': article.forme?.libelle
                    //     })
                    // });
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            })
        },

        // filterMedicament(categorie) {
        //     const list_medicament_filter = []

        //     this.medicaments.forEach(
        //         element => {
        //             if (element.attribut.Catégorie == categorie) {

        //                 list_medicament_filter.push(element)
        //             }
        //         }
        //     );
        //     this.list_medicament = list_medicament_filter
        //     return list_medicament_filter
        // },

        filterMedicament(categorie) {
            const filter = [];

            this.medicaments.forEach((element) => {
                if (element.attribut.Catégorie == categorie) {
                    filter.push(element);
                }
            });
            return filter;
        },

        async openOption(v) {
            if (v == 0) {
                v = 1;
            } else {
                v = 0;
            }

            if (this.v == 0) {
                $(".option-box").fadeIn();
                $("#option-box").removeClass("animate-fadeOutRight");
                $("#option-box").addClass("animate-fadeInRight");
            } else {
                $("#option-box").removeClass("animate-fadeInRight");
                $("#option-box").addClass("animate-fadeOutRight");
                $(".option-box").fadeOut();
            }
            this.v = v;
        },

        async closeDropOption() {
            $("#option-box").removeClass("animate-fadeInRight");
            $("#option-box").addClass("animate-fadeOutRight");
            $(".option-box").fadeOut();

            this.v = 0;
        },

        smooth(event) {
            this.closeDropOption();
            //event.preventDefault();

            // Make sure this.hash has a value before overriding default behavior

            var hash = event.target.hash;

            $("#medicament").animate(
                {
                    scrollTop: $(hash).offset().top,
                },
                800,
                function () { }
            );
        },

        /**
         * Medicament à supprimer
         */
        med_to_delete(medicament) {
            // let dosage =
            //     medicament.attribut.Dosage + medicament.attribut["Unité Dosage"];
            // dosage = dosage != null ? dosage + " " : "";
            // let forme = medicament.attribut.Forme;
            // let libelle = medicament.libelle + " ";
            let quantite = medicament.nombre_disponible;
            this.med_to_be_deleted = {
            //   user_id: this.userCredentials.user.id,
              id: medicament.medicament_id,
            //   libelle: libelle + dosage + forme,
              quantite: quantite,
            };
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $(".err-msg").fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true;
        },

        deleteMedicament() {
            this.del_loading = true;

            let confirm = document.getElementById("cfrm-del");
            let err = 0;

            if (confirm.checked == false) {
                //  Vérifie si l'utilisateur a confirmé la cloture
                $(".err-msg").fadeIn(500);
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store
                    .dispatch("deleteMedicament", this.med_to_be_deleted)
                    .then((response) => {
                        if (response > 0) {
                            this.successMedicamentDeleted();
                            this.getListeMedicamentByCategory();

                            $(".modal").modal("hide");
                        } else {
                            this.errorMedicamentDeletion();

                            $(".modal").modal("hide");
                        }
                        this.del_loading = false;
                        this.is_confirm = false;
                    });
            }
        },

        successMedicamentDeleted: function () {
            this.$toasted.show("Médicament supprimé avec succès", {
                duration: 3000,
                action: [
                    {
                        text: "X",
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        },
                    },
                ],
                theme: "toasted-primary",
                type: "success",
                position: "top-center",
            });
        },

        errorMedicamentDeletion: function () {
            this.$toasted.show("Une erreur s'est produite !", {
                duration: 3000,
                action: [
                    {
                        text: "X",
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        },
                    },
                ],
                position: "top-center",
                type: "error",
            });
        },

        handleBeforeGenerate() {
            let d = new Date()
            this.export_filename = 'Liste_Medicaments_'+d.getMilliseconds()+'.xls'
            this.is_exporting = true
        },

        getRecapStock() {
            this.recap_is_loading = true
            const data = {
                type_article_id: this.type_article_id,
            }
            store_medicaments.getRecapStock(data).then((response) => {
                this.recap_stock = response

                this.recap_is_loading = false
            })
        },

        goToRecapStock(articles, has_day, modal_title) {
            this.modal_title = modal_title
            this.produits = articles
            this.has_day = has_day
            this.modal_toggler = (this.modal_toggler == 0) ? 1 : 0

            $('.recap-produit').modal('show')
        },

        addLot(article_id) {
            this.$store.commit("SET_LOT_ARTICLE_REF_ID", article_id)

            this.$router.push({ path: `/medicaments/ajout` });
        },

        printMedicament() {
            this.can_print = true
            this.is_printing = true

            setTimeout(() => {
                
                window.print()
                this.can_print = false
                this.is_printing = false
            }, 500);
        }
    },
};
